/**
 * 组件中，公共事件监听处理
 */
export default {
    props: {
        attrs: {
            type: Object,
            default: _ => new Object()
        }
    },
    data () {
        return {
            page: {},
            tableSelectLists: []
        }
    },
    created () {
        // 监听页面数据的传递
        this.$eventHub.$on(this.$events.PAGE_DATA, this.handlePageData)
        // 监听列表选中的数据的传递
        this.$eventHub.$on(this.$events.BATCH_HANDLE_DATA, this.handleBatchData)
    },
    methods: {
        /**
         * 监听并获得页面数据
         */
        handlePageData (data) {
            if (this.attrs.mark) {
                if (this.attrs.mark == 'route') { // 标识在路由中取参数
                    this.page = this.$route.params
                } else if (data[this.attrs.mark]) {
                    this.page = data[this.attrs.mark]
                }
                // 回调函数
                this.pageDataCallback && this.pageDataCallback()
            }
        },
        /**
         * 根据传入的路径信息，获得URL和上传参数
         */
        getUrlAndParams (path) {
            let obj = {
                url: '',
                params: {}
            } // 返回的对象
            if (typeof path == 'string') {
                obj.url = path
            } else if (typeof path == 'object'){ // POST上传参数
                obj.url = path.url
                obj.params = path.params
            }
            return obj 
        },
        /**
        * 监听并获取列表中选中的数据
        */
        handleBatchData (data) {
            this.tableSelectLists = data
        }
    },
    destroyed () {
        // 销毁事件的监听
        this.$eventHub.$off(this.$events.PAGE_DATA, this.handlePageData)
        this.$eventHub.$off(this.$events.BATCH_HANDLE_DATA, this.handleBatchData)
    }
}


// WEBPACK FOOTER //
// ./src/utils/compEvent.mixin.js